import React, { useState } from 'react'
import { Card, Form, FormProps, Modal, ModalBody,Button, Col, Container, Row  } from 'react-bootstrap';
import useModal from '../../hooks/useModal';
import { Case } from '.';
import {getAllCases} from '../../services/cases';
import TextInput from '../TextInput';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import IconButton from '../IconButton';


export type customCaseFormModalProps = React.PropsWithoutRef<{
    showModal: boolean;
    existingCase?: Case;
    caseId: any;
    handleClose: () => void;
    handleSubmit: (formData: any) => void;
    formProps?: FormProps;
}>;


const CaseFormModal = ({
    showModal = false,
    existingCase,
    caseId,
    handleClose,
    handleSubmit,
    formProps,
    
    ...props
  }: customCaseFormModalProps) => {

  const [showParticipantInfoModal, handleShowParticipantInfoModal, handleCloseParticipantInfoModal
  ] = useModal();

  const [showActivityLogModal, handleShowActivityLogModal, handleCloseActivityLogModal
 ] = useModal();

  const caseList = getAllCases();
  const [showParticipantInfo, setShowParticipantInfo] = useState<boolean>(false);
  const [showActivityLog, setShowActivityLog] = useState<boolean>(false);
  const filteredCase = caseList.filter(caseItem => caseItem.id === caseId);
  const matchedCase = filteredCase.length > 0 ? filteredCase[0] : null;
  const [disabled, setDisabled] = useState(true);

  //toggle participant info
  const toggleParticipantInfo = () => {
    setShowActivityLog(false);
    setShowParticipantInfo(!showParticipantInfo);
  };

  //toggle activity log
  const toggleActivityLog = () => {
    setShowParticipantInfo(false);
    setShowActivityLog(!showActivityLog);
  };

  // Function to handle change in disabled state
  const handleChange = () => {
   // Toggle the disabled state
   setShowParticipantInfo(false);
   setShowActivityLog(false);
   setDisabled((prevDisabled: any) => !prevDisabled);
  };

  const handleUpdate = () => {
    // Toggle the disabled state
    setDisabled((prevEnabled: any) => !prevEnabled);
    handleClose()
  };

  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="xl">
      <ModalBody className="pt-12 ">
        {matchedCase && (
          <>
            <Row className="border-bottom-dark-gray">
              <Col className={'col-10 col-lg-6'}>
                <h2 className={'h2 text-sm-20-lg-24 mb-3 pt-2 mb-lg-11'}>
                  Case #{matchedCase.recordNo}
                </h2>
              </Col>
              <Col className={'col-2 col-lg-6 d-flex justify-content-end'}>
                <div className={'d-flex align-items-center px-2'}>
                  <IconButton
                    variant="icon-default"
                    icon={light('user')}
                    onClick={toggleParticipantInfo}
                    className={'me-1'}
                  /> <span onClick={toggleParticipantInfo} className="icon-label link ms-0">Participant Info</span>
                  <IconButton
                    variant="icon-default"
                    icon={light('memo-circle-info')}
                    onClick={toggleActivityLog}
                    className={'ms-2 me-1'}
                  /> <span onClick={toggleActivityLog} className="icon-label link ms-0">Activity log</span>
                  {disabled ? (
                    <Button
                      onMouseDown={handleChange}
                      className="text-nowrap m-4"
                      variant="primary"
                    >
                      Change
                    </Button>
                  ) : (
                    <Button
                      onMouseDown={handleUpdate}
                      className="text-nowrap m-4"
                      variant="primary"
                    >
                      Update
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
            <Row className={`expandable-wrapper ${showParticipantInfo ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">
                <Card className={'mt-4'}>
                  <Card.Body>
                    <Card.Title>Participant Info</Card.Title>
                    <Container className={'px-0 d-flex flex-column'}>
                      <Row className="m-2 pb-2">
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-2">
                            <Col className="col-4">Name: </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>{matchedCase.participant}</span></Col>
                          </Row>
                        </Col>
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-2">
                            <Col className="col-4">EID: </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>XXXXXXXXXX</span></Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="m-2">
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-2">
                            <Col className="col-4">Street: </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>123 Front Street</span></Col>
                          </Row>
                        </Col>
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-2">
                            <Col className="col-4">SSN: </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>XXXXXXXXXX</span></Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="m-2">
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-2">
                            <Col className="col-4">City: </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>Dallas</span></Col>
                          </Row>
                        </Col>
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-8">
                            <Col className="col-4">Employee Status / Date: </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>Active MM/DD/YYYY</span></Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="m-2">
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-2">
                            <Col className="col-4">State: </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>TX</span></Col>
                          </Row>
                        </Col>
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-2">
                            <Col className="col-4">Hire Date : </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>MM/DD/YYYY</span></Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="m-2">
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-2">
                            <Col className="col-4">ZIP: </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>XXXXXX</span></Col>
                          </Row>
                        </Col>
                        <Col className="col-12 col-lg-6 col">
                          <Row className="mt-2">
                            <Col className="col-4">Phone: </Col>
                            <Col className="col-8"><span className={'text-dark-gray-50'}>(XXX)-XXX-XXXX</span></Col>
                          </Row>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
            </Row>
            <Row className={`expandable-wrapper ${showActivityLog ? 'open' : ''}`}>
            <div className="w-100 justify-content-center">
                <Card className={'mt-4'}>
                  <Card.Body>
                    <Card.Title>Activity Log</Card.Title>
                    <Container className={'px-0 d-flex flex-column'}>
                      <Row className={'d-none d-lg-flex mt-10 pb-5 border-bottom-light-gray-2px text-fs-6'}>
                        <Col lg={2}>
                          <div className={'d-flex align-items-center'}>In-date</div>
                        </Col>
                        <Col lg={2}>
                          <div className={'d-flex align-items-center'}>Process State</div>
                        </Col>
                        <Col lg={2}>
                          <div className={'d-flex align-items-center'}>Trans Type</div>
                        </Col>
                        <Col lg={2}>
                          <div className={'d-flex align-items-center'}>Passed To</div>
                        </Col>
                        <Col lg={2}>
                          <div className={'d-flex align-items-center'}>Out-date</div>
                        </Col>
                        <Col lg={2}>
                          <div className={'d-flex align-items-center'}>Updated By</div>
                        </Col>
                      </Row>
                      <Row className={'my-5 pb-5 border-bottom text-fs-6 fw-normal-sm-light-lg'}>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >In-date:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>4/04/2024</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Process State:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Closed</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Trans Type:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Detailed Calculation</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Passed To:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Chung, Vicky</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Out-date:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>-</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Updated By:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Chung, Vicky</span>
                        </Col>
                      </Row>
                      <Row className={'my-5 pb-5 border-bottom text-fs-6 fw-normal-sm-light-lg'}>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >In-date:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>4/04/2024</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Process State:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>In-Process</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Trans Type:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Detailed Calculation</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Passed To:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Chung, Vicky</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Out-date:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>-</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Updated By:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Chung, Vicky</span>
                        </Col>
                      </Row>
                      <Row className={'my-5 pb-5 border-bottom text-fs-6 fw-normal-sm-light-lg'}>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >In-date:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>4/04/2024</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Process State:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>In-Process</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Trans Type:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Detailed Calculation</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Passed To:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Chung, Vicky</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Out-date:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>-</span>
                        </Col>
                        <Col lg={2} className="d-flex d-lg-block">
                          <h2 className={
                            'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'
                          }
                          >Updated By:
                          </h2>
                          <span className={'text-end w-100 align-items-center'}>Chung, Vicky</span>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div>
            </Row>

            <Form id="caseForm">
            <Row className="m-8">
              <Col className="col-12 col-lg-12 col">
                {' '}
                <span className={'h6'}>Name: {matchedCase.participant}</span>
              </Col>
            </Row>

            <Row className="m-8">
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Plan</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Define Benefits"
                      value={matchedCase.plan}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Priority</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Default to Normal"
                      value={matchedCase.plan}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Initiator</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Default to Participant"
                      value={matchedCase.initiator}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="m-8">
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Category</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder=" "
                      value={matchedCase.category}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Record Status</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Default to Standard Process"
                      value={matchedCase.recordStatus}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Method</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Default to Phone Call #"
                      value={matchedCase.method}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="m-8">
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Subject</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Benefit Calculation"
                      value={matchedCase.subject}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">QA Status</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Default to None"
                      value={matchedCase.qaStatus}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Auth Method</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Default"
                      value={matchedCase.auxMethod}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="m-8">
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Detail</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="PIN Reset"
                      value={matchedCase.details}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Inbox</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Default to Agents Inbox"
                      value={matchedCase.inbox}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Scope</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="Default to Regular"
                      value={matchedCase.scope}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="m-8">
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Record Type</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder=" "
                      value={matchedCase.caseType}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="m-8">
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Callback</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="xxx-xxx-xxx"
                      value={matchedCase.callback1}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Callback</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="xxx-xxx-xxx"
                      value={matchedCase.callback2}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="col-12 col-lg-4 col">
                <Row className="mt-8">
                  <Col className="col-3 p-5">Followup</Col>
                  <Col className="col-8">
                    <TextInput
                      placeholder="xxx-xxx-xxx"
                      value={matchedCase.followup}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="m-8">
              <Col className="col-12 col p-5">
                <div className=" text-input-custom">
                  <Form.Group className="mb-3" controlId="comments">
                    <Form.Control
                      className=""
                      as="textarea"
                      placeholder="Comments (1000 chars max)"
                      rows={4}
                      disabled={disabled}
                    />
                  </Form.Group>
                </div>
              </Col>
            </Row>
            <Row className="m-8">
              <section className="py-11 py-lg-12 d-flex justify-content-center flex-column flex-lg-row">
                <Button
                  onMouseDown={handleClose}
                  className=" reset-button m-4"
                  variant="primary-outline"
                >
                  Cancel
                </Button>

                
              </section>
            </Row>
            </Form>
          </>
        )}
      </ModalBody>
    </Modal>
  );
}

export default CaseFormModal